import { Img } from "@/components/ui/img";
import { FilmSlate, FileText } from "@phosphor-icons/react";
import { formatMediaBytes } from "./utils";
import type { MediaItem } from "@/types";

export function MediaCard({
  item,
  onClick,
}: {
  item: MediaItem;
  onClick: () => void;
}) {
  const isImage = item.mimeType.startsWith("image/");
  const isVideo = item.mimeType.startsWith("video/");
  const thumbUrl = item.urls.xsmall || item.urls.small || item.urls.full;

  return (
    <button
      onClick={onClick}
      className="group flex flex-col overflow-hidden rounded-xl border bg-card text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="relative aspect-square overflow-hidden bg-muted/30">
        {isImage && thumbUrl ? (
          <Img
            src={thumbUrl}
            alt={item.originalName}
            className="size-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="flex size-full items-center justify-center bg-gradient-to-br from-muted/20 via-muted/40 to-muted/20">
            {isVideo ? (
              <FilmSlate className="size-10 text-muted-foreground/30" />
            ) : (
              <FileText className="size-10 text-muted-foreground/30" />
            )}
          </div>
        )}
        <span className="absolute right-2 top-2 rounded-full bg-black/50 px-2 py-0.5 text-[10px] font-medium text-white backdrop-blur-sm">
          {item.folder}
        </span>
      </div>
      <div className="flex flex-col gap-0.5 p-3">
        <p className="truncate text-sm font-medium text-foreground">
          {item.originalName}
        </p>
        <p className="text-xs text-muted-foreground">
          {formatMediaBytes(item.size)}
        </p>
      </div>
    </button>
  );
}
